export default __webpack_public_path__ + "static/media/python.eb6a2d20.svg";